import { Box, Skeleton } from "@mui/material";

type ConsentInputSkeletonProps = {
    height?: number;
    label: string;
    width?: number | string;
};

export const ConsentInputSkeleton = ({ height = 56, label, width = "100%" }: ConsentInputSkeletonProps) => (
    <Box aria-label={label} aria-live="polite" role="status" sx={{ width }}>
        <Skeleton
            height={height}
            variant="rounded"
            sx={(theme) => ({
                borderRadius: theme.spacing(1.5),
            })}
        />
    </Box>
);
